"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetEmail = resetEmail;
exports.updatePass = updatePass;

var _request = _interopRequireDefault(require("@/utils/request"));

function resetEmail(data) {
  return (0, _request.default)({
    url: 'api/code/resetEmail?email=' + data,
    method: 'post'
  });
}

function updatePass(pass) {
  return (0, _request.default)({
    url: 'api/users/updatePass/' + pass,
    method: 'get'
  });
}